import {useEffect} from 'react'

const parentCheck = (classNames = [], event) => {
	if (event?.target?.parentElement) {
		const parentsClass = event?.target?.parentElement?.offsetParent?.classList || []
		return classNames.some(c => [...parentsClass].includes(c))
	}
	return false
}

function useOutsideClick(ref, onClick, {classNames = [], checkParents = true} = {}) {
	useEffect(() => {
		if (typeof window === 'undefined') return

		function handleClickOutside(event) {
			const refClicked = ref.current && ref.current.contains(event.target)
			const classNameClicked = classNames.some(c => [...event.target.classList].includes(c))
			const offsetClicked = checkParents && parentCheck(classNames, event)
			if (!refClicked && !classNameClicked && !offsetClicked) {
				onClick()
			}
		}
		document.addEventListener('mousedown', handleClickOutside)
		return () => {
			document.removeEventListener('mousedown', handleClickOutside)
		}
	}, [ref])
}

export default useOutsideClick
